import axios from "axios";
import { req, reqF } from "./axiosFun";

// 获取菜单
export const GetMenuList = (params) => {
	return reqF("post", "/api/sysConfig/SysConfig/GetMenuList", params);
};

// 获取菜单列表信息——树级结构
export const GetMenuTreeList = (params) => {
	return reqF("post", "/api/sysConfig/SysConfig/GetMenuTreeList", params);
};

// 保存菜单
export const SaveMenu = (params) => {
	return reqF("post", "/api/sysConfig/SysConfig/SaveMenu", params);
};

// 获取菜单详情
export const GetMenuByKeyId = (params) => {
	return reqF("post", "/api/sysConfig/SysConfig/GetMenuByKeyId", params);
};

// 删除菜单
export const DeleteMenu = (params) => {
	return reqF("post", "/api/sysConfig/SysConfig/DeleteMenu", params);
};

// 获取菜单列表信息——树级结构
export const GetMenuTreeAllList = (params) => {
	return reqF("post", "/api/sysConfig/SysConfig/GetMenuTreeAllList", params);
};

// 获取上线菜单列表信息——树级结构
export const GetOnLineMenuTreeList = (params) => {
	return reqF("post", "/api/sysConfig/SysConfig/GetOnLineMenuTreeList", params);
};



// 获取第二层菜单列表信息
export const GetSecondMenuList = (params) => {
	return reqF("post", "/api/sysConfig/SysConfig/GetSecondMenuList", params);
};






// 获取第二层上线菜单列表信息
export const GetSecondOnlineMenuList = (params) => {
	return reqF("post", "/api/sysConfig/SysConfig/GetSecondOnlineMenuList", params);
};

// 获取角色拥有的二级菜单列表
export const GetRoleLinkSecondMenuList = (params) => {
	return reqF("post", "/api/sysConfig/Role/GetRoleLinkSecondMenuList", params);
};

// 获取角色的菜单权限
export const GetRoleLinkMenu2List = (params) => {
	return reqF("post", "/api/sysConfig/Role/GetRoleLinkMenu2List", params);
};

// 保存角色关联菜单按钮权限2
export const SaveRoleLinkMenu2 = (params) => {
	return reqF("post", "/api/sysConfig/Role/SaveRoleLinkMenu2", params);
};

// 获取角色拥有的菜单列表——树级结构
export const GetRoleMenuTreeList = (params) => {
	return reqF("post", "/api/sysConfig/Role/GetRoleMenuTreeList", params);
};

// 设置菜单是否显示
export const SetMenuIsShow = (params) => {
	return reqF("post", "/api/sysConfig/SysConfig/SetMenuIsShow", params);
};

// 设置菜单是否上线
export const SetMenuIsOnLine = (params) => {
	return reqF("post", "/api/sysConfig/SysConfig/SetMenuIsOnLine", params);
};

/**
 * 权限按钮
 */

// 分页获取权限库列表
export const GetBtnOpLibraryList = (params) => {
	return reqF("post", "/api/sysConfig/BtnOpLib/GetBtnOpLibraryList", params);
};

// 保存按钮权限
export const SaveBtnOpLibrary = (params) => {
	return reqF("post", "/api/sysConfig/BtnOpLib/SaveBtnOpLibrary", params);
};
// 删除按钮权限信息
export const DelBtnOpLibrary = (params) => {
	return reqF("post", "/api/sysConfig/BtnOpLib/DelBtnOpLibrary", params);
};

// 获取关联的权限按钮列表
export const GetLinkBtnOpList = (params) => {
	return reqF("post", "/api/sysConfig/BtnOpLib/GetLinkBtnOpList", params);
};

// 获取未关联的权限按钮列表
export const GetUnLinkBtnOpList = (params) => {
	return reqF("post", "/api/sysConfig/BtnOpLib/GetUnLinkBtnOpList", params);
};

// 保存关联的按钮权限信息
export const SaveBtnOpLink = (params) => {
	return reqF("post", "/api/sysConfig/BtnOpLib/SaveBtnOpLink", params);
};

/**
 * 角色关联的菜单
 */

// 获取人员的快捷菜单列表
export const GetUserMenuList = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserMenuList", params);
};

// 保存人员的快捷菜单信息
export const SaveUserMenuList = (params) => {
	return reqF("post", "/api/sysConfig/User/SaveUserMenuList", params);
};
